var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { tokens } from '@servicetitan/tokens/core';
export const Backdrop = (_a) => {
    var { animate, className, onClick, open = true } = _a, rest = __rest(_a, ["animate", "className", "onClick", "open"]);
    const handleClick = (e) => {
        e.stopPropagation();
        if (e.target !== e.currentTarget)
            return;
        if (onClick)
            onClick(e);
    };
    const BackdropClassNames = classnames('Backdrop', className, {
        'Backdrop--is-open': open,
        'Backdrop--has-onClick': onClick,
        'cursor-not-allowed': !onClick,
    });
    const durationSlow = parseInt(tokens.durationSlow, 10) / 1000; // '300ms' -> 0.3
    const framerAnimation = {
        initial: { opacity: 0 },
        animate: { opacity: 0.6 },
        exit: { opacity: 0 },
        transition: { type: 'linear', duration: durationSlow },
    };
    const Animate = animate ? AnimatePresence : React.Fragment;
    const ScreenEl = animate ? motion.div : 'div';
    const ScreenProps = Object.assign({ className: BackdropClassNames, onClick: handleClick, style: { opacity: !animate && 0.6 } }, (animate && framerAnimation));
    return (React.createElement(Animate, null, open && (React.createElement(ScreenEl, Object.assign({ "data-anvil-component": "Backdrop" }, ScreenProps, rest)))));
};
//# sourceMappingURL=Backdrop.js.map